import axios from 'axios';
import { getUserData } from './storageService';

const API_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/ocr`
  : 'https://backend-c-0mxm.onrender.com/api/ocr';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const user = getUserData();
  if (user) {
    config.headers.Authorization = `Bearer ${user.userId || user.token}`;
  }
  return config;
});

/**
 * Gửi ảnh lên server để Gemini Vision AI đọc GMV
 */
export const extractGMVFromImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/extract-gmv', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    });
    return { success: true, data: response.data.data };
  } catch (error) {
    if (error.response) {
      return { success: false, error: error.response.data.message || 'Lỗi đọc ảnh' };
    }
    if (error.code === 'ECONNABORTED') {
      return { success: false, error: 'Timeout - vui lòng thử lại' };
    }
    return { success: false, error: 'Không thể kết nối đến server' };
  }
};
